import { asyncDefaults, makeAsyncReducer, mergeReducers } from '../../../ui-lottery/src/utils/async_utils';
import * as types from '../constants/actions';
import { ApiKeyDefaults } from '../props/apiKey';

const fetchApiKey = makeAsyncReducer(types.FETCH_APIKEY);
const generateApiKey = makeAsyncReducer(types.GENERATE_APIKEY);

export default mergeReducers(asyncDefaults(ApiKeyDefaults), types.PREFIX, fetchApiKey, generateApiKey);
